import { Component, Input, Output, EventEmitter, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
    selector: 'app-toggle-dropdown',
    templateUrl: './toggle-dropdown.component.html',
    styleUrls: ['./toggle-dropdown.component.css'],
})
export class ToggleDropdownComponent implements OnInit {
    @ViewChild('dropdownMenu')
    dropdownMenu!: ElementRef;
    @Input() text = 'Filter'; // Default text
    @Input() iconSrc = 'assets/icons/redesign/icon-filter.svg'; // Default icon source
    @Input() selectedFilter = 'Filter'; // Initialize with 'Filter'
    @Input() isDisabled = false;
    filters = ['Option 1', 'Option 2', 'Option 3']; // Example filter options

    @Output() filterSelected = new EventEmitter();
    @Output() findByName = new EventEmitter<string>();
    @Output() sortSelected = new EventEmitter();

    sortByDateGroup!: FormGroup;
    sortByNameGroup!: FormGroup;
    filterByDateGroup!: FormGroup;

    // sortType = null;
    // sortBy = null;

    sortType = 'date';
    sortBy = 'desc';

    ngOnInit() {
        this.initiateForms();
    }

    initiateForms() {
        this.sortByDateGroup = new FormGroup({
            //sortByDate: new FormControl(null, [Validators.required]),
            sortByDate: new FormControl('desc', [Validators.required]),
        });
        this.sortByNameGroup = new FormGroup({
            sortByName: new FormControl(null, [Validators.required]),
        });
        this.filterByDateGroup = new FormGroup({
            dateFieldFrom: new FormControl(null, [Validators.required]),
            dateFieldTo: new FormControl(null, [Validators.required]),
        });
    }

    selectFilter(filter: string) {
        this.selectedFilter = filter; // Update selected filter
        this.filterSelected.emit(filter);
        this.closeDropdown();
    }

    searchByDate() {
        const datefieldControlFrom = this.filterByDateGroup?.get('dateFieldFrom')?.value;
        const datefieldControlTo = this.filterByDateGroup?.get('dateFieldTo')?.value;
        this.closeDropdown();
    }

    clearDate() {
        //console.log('clearDate');
    }

    setSortByDate(e: any) {
        this.sortByNameGroup?.get('sortByName')?.reset();
        this.sortType = 'date';
        this.sortBy = e.target.value;
    }

    setSortByName(e: any) {
        this.sortByDateGroup?.get('sortByDate')?.reset();
        this.sortType = 'name';
        this.sortBy = e.target.value;
    }

    clearSort() {
        this.sortByDateGroup?.get('sortByDate')?.reset();
        this.sortByNameGroup?.get('sortByName')?.reset();
        this.sortType = 'date';
        this.sortBy = 'desc';
        this.sortByDateGroup = new FormGroup({
            sortByDate: new FormControl('desc', [Validators.required]),
        });
        this.sortSelected.emit({
            sortType: this.sortType,
            sortBy: this.sortBy,
        });
        this.closeDropdown();
    }

    applySort(e: any) {
        this.sortSelected.emit({
            sortType: this.sortType,
            sortBy: this.sortBy,
        });
        this.closeDropdown();
    }

    valueAdded(event: any) {
        const datefieldControlFrom = this.filterByDateGroup?.get('dateFieldFrom')?.value;
        const datefieldControlTo = this.filterByDateGroup?.get('dateFieldTo')?.value;
    }

    closeDropdown() {
        // Close the dropdown
        if (this.dropdownMenu && this.dropdownMenu.nativeElement) {
            this.dropdownMenu.nativeElement.classList.remove('show');
        }
        //this.clearSort();
        // Optional: Change the text or other UI updates to indicate dropdown is closed
        //this.text = 'Closed';
    }

    searchByName(name: string) {
        this.findByName.emit(name);
    }
}
